/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { EscrowContract, Transaction } from '../types/escrow';
import { fetchEscrows } from './api';

// Uses the centralized API which includes fallbacks to the mock data previously imported here.

export const fetchSuiEscrows = async (wallet: string): Promise<EscrowContract[]> => {
    const allEscrows = await fetchEscrows(wallet);
    return allEscrows.filter(c => c.chain === 'SUI');
};

export const fetchSolanaEscrows = async (wallet: string): Promise<EscrowContract[]> => {
    const allEscrows = await fetchEscrows(wallet);
    return allEscrows.filter(c => c.chain === 'SOL');
};

// Keeping these for legacy compat if needed, but they should ideally route through transactionService
export const fetchSuiTransactions = async (wallet: string): Promise<Transaction[]> => {
    // Mock implementation for legacy calls
    return [];
}

export const fetchSolanaTransactions = async (wallet: string): Promise<Transaction[]> => {
     // Mock implementation for legacy calls
    return [];
}